import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import axios from 'src/app/Service/axios';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { OtherService } from 'src/app/Service/other.service';
import { VoltageSpeedDashboard, VoltageSpeedDashboardRequest } from './voltage-with-speed.models';

@Component({
  selector: 'app-voltage-with-speed',
  templateUrl: './voltage-with-speed.component.html',
  styleUrls: ['./voltage-with-speed.component.css']
})
export class VoltageWithSpeedComponent implements OnInit {
  readonly requestForm = new FormGroup({
    iSystemUser: new FormControl(0),
    strSession: new FormControl(''),
    strUnitID: new FormControl(''),
    strDate: new FormControl(''),
  });
  
  dashboard: VoltageSpeedDashboard | null = null;
  loading = false;
  error = '';

  constructor(
    private readonly gurdService: GurdServiceService,
    private readonly location: Location,
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    private readonly notification: NotificationService,
    private readonly other: OtherService,
  ) { }

  ngOnInit(): void {
    this.requestForm.patchValue({
      iSystemUser: Number(this.gurdService.decrypt(localStorage.getItem('ID'))),
      strSession: this.gurdService.decrypt(localStorage.getItem('Session')),
      strUnitID: this.route.snapshot.paramMap.get('id') || '',
      strDate: this.gurdService.decrypt(localStorage.getItem('reportDataZa')) || '',
    });
    const { strUnitID, strDate } = this.requestForm.value;
    if (!strUnitID || !strDate) {
      this.error = 'شناسه خودرو یا تاریخ گزارش مشخص نیست. گزارش را از مشخصات خودرو باز کنید.';
      this.notification.showError(this.error);
      return;
    }
    void this.loadDashboard();
  }

  get strDate(): string {
    return this.requestForm.get('strDate')!.value;
  }

  async loadDashboard(): Promise<void> {
    if (this.loading) return;
    this.dashboard = null;
    this.error = '';
    this.loading = true;

    try {
      const payload: VoltageSpeedDashboardRequest = this.requestForm.value;
      const response = await axios.post('MobileHistory_VoltageSpeed_Dashboard', payload, {
        timeout: 30000,
      });
      const data = typeof response.data === 'string' ? JSON.parse(response.data) : response.data;
      if (!data || typeof data !== 'object') throw new Error('قالب پاسخ سرویس معتبر نیست.');
      if (data.ISSessionExpired || data.ISessionExpired) {
        this.handleExpiredSession();
        return;
      }
      if (data.iResult !== undefined && Number(data.iResult) === 0) {
        throw new Error(data.strError || 'دریافت اطلاعات داشبورد با خطا مواجه شد.');
      }
      this.dashboard = data;
    } catch (error) {
      this.error = error instanceof Error && !('isAxiosError' in error)
        ? error.message : 'دریافت اطلاعات داشبورد با خطا مواجه شد. دوباره تلاش کنید.';
      this.notification.showError(this.error);
    } finally {
      this.loading = false;
    }
  }

  private handleExpiredSession(): void {
    this.notification.showError('لطفا وارد سیستم شوید');
    this.other.removeLocalStorage();
    void this.router.navigate(['login'], { queryParams: { error: 'لطفا وارد سیستم شوید' } });
  }

  goBack(): void {
    this.location.back();
  }

}
